module.exports = __webpack_public_path__ + "img/20201123.53cf97a8.png";